import axios from "axios";

export const BaseURL = "/api/";
// export const BaseURL = "http://185.239.104.87:3500/api/";
// export const BaseURL = "http://188.121.96.178:3500/api/";

export const CallApi = (apiName, method, body, formData = false) => {
  return new Promise((success, error) => {
    if (method.toLowerCase().trim() === "post") {
      axios({
        method: "post",
        url: BaseURL + apiName,
        data: body,
        headers: {
          "Content-Type": !formData
            ? "application/json"
            : "multipart/form-data",
        },
      })
        .then(function (response) {
          success(response.data);
        })
        .catch(function (err) {
          error(apiName + ": " + err.response.data.message);
        });
    } else {
      axios({
        method: "get",
        url: BaseURL + apiName,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic c2l0ZTpzaXRl",
        },
      })
        .then(function (response) {
          success(response.data);
        })
        .catch(function (err) {
          error(apiName + ": " + err.response.data.message);
        });
    }
  });
};
